function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Nuevo-portal",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Xl/Portal-Asociado-Menu",
  transform: "translate(-153.000000, -12.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "UI-icon/menu_hamburguesa_Black-Copy-2",
  transform: "translate(153.000000, 12.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(2.844427, 5.727554)",
  stroke: "#EB5F0A",
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("line", {
  x1: 0,
  y1: 14.7732198,
  x2: 22.755418,
  y2: 14.7732198,
  id: "Line"
}), /*#__PURE__*/React.createElement("line", {
  x1: 0,
  y1: 7.67105263,
  x2: 22.6047969,
  y2: 7.67105263,
  id: "Line"
}), /*#__PURE__*/React.createElement("line", {
  x1: 0,
  y1: 0.568885449,
  x2: 22.755418,
  y2: 0.568885449,
  id: "Line"
})), /*#__PURE__*/React.createElement("rect", {
  id: "Bounds",
  x: 0,
  y: 0,
  width: 28,
  height: 28
}))));

function SvgIconMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "E67DA03D-4BE9-475F-9780-2D669EAD2397") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenu);
export default __webpack_public_path__ + "static/media/icon_menu.97867a22.svg";
export { ForwardRef as ReactComponent };